export enum GolferType {
  REGISTERED_GOLFER = 'registeredGolfer',
  GUEST_PLAYER = 'guestPlayer',
}

export const GolferTypeDisplayMap: Record<GolferType, string> = {
  [GolferType.REGISTERED_GOLFER]: 'Registered',
  [GolferType.GUEST_PLAYER]: 'Social Golfer',
};

export type GolferStatsData = {
  id: string;
  email: string;
  name: string;
  surname: string;
  mobileNumber: string;
  holeInOnes: number;
  type: GolferType;
  golfRegistrationNumber?: string;
  country?: string;
};

export type GolferDetails = {
  id: string;
  name: string;
  mobileNumber: string;
  email: string;
  accountType: string;
  registrationNo: string;
  country: string;
  holeInOnes: number | string;
};
